const Copy = () => {
  return (
    <div className="bg-yellow font-medium gap-x-8 gap-y-2 grid p-4 sm:grid-cols-2 lg:px-24">
      <div>
        &copy; {new Date().getFullYear()} {process.env.REACT_APP_NAME}
      </div>

      <div className="sm:text-right">
        Made in{" "}
        <a href="https://xdigital.agency/" rel="noreferrer" target="_blank">
          xdigital
        </a>
      </div>
    </div>
  );
};

export default Copy;
